/**
 * Hover Sweep directive options container.
 *
 * Visual variants (duration, easing, background color) are owned by CSS — author them as
 * additional classes on the host (e.g. `.hover-sweep.is-subtle`) that override
 * `--hover-duration`, `--hover-timing-function`, `--hover-background-color`. This file is
 * kept as a placeholder for future runtime options.
 */
export const hoverSweepOptions = {
  default: {}
};
